import type { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction | null = null;

export function registerNavigate(fn: NavigateFunction) {
  navigate = fn;
}

export function redirectToSignIn() {
  navigate?.("/auth/sign-in", { replace: true });
}
